import DropZoneView from "./components/DropZoneView";
import DropZoneWindow from "./components/DropZoneWindow";
import EditorView from "./components/EditorView";
import { Modal } from "./components/Modal";
import { NetworkConnector } from "./components/NetworkConnector";
import { ProgressBar } from "./components/ProgressBar";
import { AppState, PackEditorCallbacks } from "./core/EditorTypes";
import { FileEvent } from "./FileProcessor";
import { CreateOrImportPage } from "./pages/CreateOrImportPage";
import { HelpPage } from "./pages/HelpPage";

type Props = AppState & {
  packEditorCallbacks: PackEditorCallbacks;
};

let selectedImportRep = "";

export const AppContent = (props: Props) => {
  const {
    route,
    modal,
    modalData,
    importState,
    importProgress,
    networkState,
    packAttachments,
    packCurrent,
    packEditorCallbacks,
  } = props;

  const {
    upload,
    save,
    reset,
    setModal,
    onPackFileEvent,
    addLines2,
    addEmptyRep,
    saveAsLines,
    convertHtmlToMd,
    alphabetize,
    notifyModalListeners,
    slice,
    addConceptForAllAttachments,
    clearAllAttachments,
    fixConceptIds,
  } = packEditorCallbacks;

  const loadScreen = (
    (importState === "importing" ||
        importState === "packaging" ||
        importState === "transferring")
      ? (
        <div style={{ margin: 100 }}>
          <p>
            {importState === "importing"
              ? "Importing..."
              : importState === "packaging"
              ? "Packaging..."
              : "Transferring..."}
          </p>
          <ProgressBar progress={importProgress} />
        </div>
      )
      : null
  );
  const content = route === "index"
    ? (
      <div className="main">
        {loadScreen != null
          ? loadScreen
          : <CreateOrImportPage packEditorCallbacks={packEditorCallbacks} />}
      </div>
    )
    : (
      <div className="main">
        {loadScreen ??
          (
            <EditorView
              pack={packCurrent!}
              packAttachments={packAttachments}
              networkState={networkState}
              packEditorCallbacks={packEditorCallbacks}
              // @ts-ignore
              upload={upload}
              save={save}
              reset={reset}
            />
          )}
      </div>
    );

  return (
    <>
      {modal !== "none" && (
        <Modal
          close={() => setModal("none")}
        >
          {modal === "slice" && (
            <div>
              <h2>
                There are {packCurrent?.data.concepts.length ?? 0}{" "}
                concepts in this pack. How many would you like to slice/keep?
              </h2>
              <p>
                <input type="number" id="slice-number" />
                <button
                  onClick={() => {
                    const num = parseInt(
                      (document.getElementById(
                        "slice-number",
                      ) as HTMLInputElement)?.value ?? "0",
                    );
                    slice(num);
                    setModal("none");
                  }}
                >
                  Slice
                </button>
              </p>
            </div>
          )}
          {modal === "anki_choose_deck" && (
            <div>
              <h2>Multiple decks are available in this file, choose one.</h2>
              <p>
                {(modalData as string[]).map((deckKey) => (
                  <button
                    key={deckKey}
                    onClick={() => {
                      notifyModalListeners("anki_choose_deck", deckKey);
                    }}
                  >
                    {deckKey}
                  </button>
                ))}
              </p>
            </div>
          )}
          {modal === "help" &&
            (
              <div>
                <HelpPage />
              </div>
            )}
          {(["add_lines2", "add_empty_rep", "add_lines", "alphabetize"]
            .includes(modal)) && (
            <>
              <h2>
                {modal === "add_lines2"
                  ? `Import file into: "${selectedImportRep}"`
                  : `Which representation to 
                    ${
                    modal === "add_empty_rep"
                      ? "add to all concepts"
                      : modal === "add_lines"
                      ? "import into"
                      : modal === "alphabetize"
                      ? "alphabetize by"
                      : "export as a list"
                  }?`}
              </h2>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-evenly",
                  alignItems: "center",
                }}
              >
                {modal === "add_lines2"
                  ? (
                    <DropZoneView
                      onFileEvent={onPackFileEvent}
                      onFile={(text) => {
                        console.log("da file", text);

                        const reps = text.split("\n");
                        const repKey = selectedImportRep;

                        addLines2(reps, repKey);
                      }}
                      other={{
                        onChooseDeck: packEditorCallbacks.onChooseDeck,
                        onChooseColumns: packEditorCallbacks.onChooseColumns,
                      }}
                    />
                  )
                  : [
                    ...Object.keys(packCurrent?.data?.reps || []),
                    ...(modal === "alphabetize" ? ["{{ID}}"] : []),
                  ].map((
                    rep,
                  ) => (
                    <button
                      key={rep}
                      className="btn"
                      onClick={() => {
                        if (modal === "add_empty_rep") {
                          addEmptyRep(rep);
                        } else if (modal === "save_lines") {
                          saveAsLines(rep);
                        } else if (modal === "add_lines") {
                          // this.addLines(rep);
                          selectedImportRep = rep;
                          setModal("add_lines2");
                          return;
                        } else if (modal === "alphabetize") {
                          alphabetize(
                            rep,
                            (document.getElementById(
                              "alphabetize-reverse",
                            ) as HTMLInputElement)?.checked || false,
                          );
                        }

                        setModal("none");
                      }}
                    >
                      {rep}
                    </button>
                  ))}
              </div>
              {modal === "alphabetize" && (
                // reverse toggle
                <div>
                  <input type="checkbox" id="alphabetize-reverse" />
                  <label htmlFor="alphabetize-reverse">Reverse</label>
                </div>
              )}
            </>
          )}
        </Modal>
      )}
      <div className="titlebar">
        <h1 className="title padding" style={{whiteSpace: 'nowrap'}}>
          <img
            src="logo.png"
            alt="logo"
            style={{
              transform: "translateY(20%)",
              marginRight: "8px",
              height: "1.33em",
              width: "1.33em",
            }}
          />Optimem Editor
        </h1>
        {packCurrent
          ? (
            <>
              <button
                className=""
                onClick={() => {
                  setModal("help");
                }}
              >
                <strong>⛑️ Help</strong>
              </button>
              <button className="" onClick={save}>
                <strong>💾 Save</strong>
                {
                  /* <br />
                <span style={{ fontSize: "0.75em" }}>to pc</span> */
                }
              </button>
              <button className="" onClick={reset}>
                <strong>🅧 Reset</strong>
                {
                  /* <br />
                <span style={{ fontSize: "0.75em" }}>new pack</span> */
                }
              </button>
              {networkState === "connected" && (
                <button className="btn special" onClick={upload}>
                  <strong>send</strong>
                  <br />
                  <span style={{ fontSize: "0.75em" }}>to phone</span>
                </button>
              )}
              <select
                className="dropdown"
                value={"more options"}
                onChange={(e) => {
                  if (e.target.value === "save_lines") {
                    setModal("save_lines");
                  }
                  if (e.target.value === "add_lines") {
                    setModal("add_lines");
                  }
                  if (e.target.value === "alphabetize") {
                    setModal("alphabetize");
                  }
                  if (e.target.value === "add_empty_rep") {
                    setModal("add_empty_rep");
                  }
                  if (e.target.value === "convert_html_to_md") {
                    convertHtmlToMd();
                  }
                  if (e.target.value === "add_concept_for_all_attachments") {
                    addConceptForAllAttachments();
                  }
                  if (e.target.value === "slice") {
                    slice(null);
                  }
                  if (e.target.value === "clear_all_attachments") {
                    clearAllAttachments();
                  }
                  if (e.target.value === "fix_concept_ids") {
                    fixConceptIds();
                  }
                }}
              >
                <option value="">more options</option>
                <option value="slice">slice number of concepts</option>
                <option value="alphabetize">alphabetize concepts</option>
                <option value="save_lines">export list of reps</option>
                <option value="add_lines">import list of reps</option>
                <option value="add_empty_rep">add empty rep to all</option>
                <option value="convert_html_to_md">convert html to md</option>
                <option value="add_concept_for_all_attachments">
                  add concept for each attachment
                </option>
                <option value="clear_all_attachments">
                  clear all attachments
                </option>
                <option value="fix_concept_ids">fix concept ids</option>
              </select>
            </>
          )
          : (
            <button
              className=""
              onClick={() => {
                setModal("help");
              }}
            >
              <strong>⛑️ Help</strong>
            </button>
          )}
        <NetworkConnector
          networkState={networkState}
        />
      </div>
      {content}
      {!packCurrent && (
        <DropZoneWindow
          onFile={packEditorCallbacks.onPackFile}
          onFileEvent={packEditorCallbacks.onPackFileEvent}
          attach={false}
          other={{
            onChooseDeck: packEditorCallbacks.onChooseDeck,
            onChooseColumns: packEditorCallbacks.onChooseColumns,
          }}
        />
      )}
    </>
  );
};
